import React from "react";
import styled from "styled-components";

const NHSNumberInput = ({ value, onChange, disabled = false }) => {
  const formatNHSNumber = (value) => {
    // Remove all non-digit characters
    const digitsOnly = value.replace(/\D/g, "");
    // Format as XXX XXX XXXX
    let formatted = digitsOnly.slice(0, 3);
    if (digitsOnly.length > 3) {
      formatted += " " + digitsOnly.slice(3, 6);
    }
    if (digitsOnly.length > 6) {
      formatted += " " + digitsOnly.slice(6, 10);
    }
    return formatted;
  };

  const handleInputChange = (e) => {
    if (!disabled) {
      const formattedValue = formatNHSNumber(e.target.value);
      onChange(formattedValue); // Call the parent's onChange function with the formatted value
    }
  };

  return (
    <Input
      type="text"
      value={value}
      onChange={handleInputChange}
      maxLength="12"
      placeholder="XXX XXX XXXX"
      pattern="\d{3}\s\d{3}\s\d{4}"
      title="Please enter an NHS number in the format XXX XXX XXXX"
      required
      disabled={disabled} // Disable input if the prop is true
    />
  );
};

const Input = styled.input`
  display: flex;
  padding: 12px 16px;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--Colors-Neutral-400, #ced4da);
  background: var(--Colors-Neutral-100, #fff);
  cursor: ${({ disabled }) =>
    disabled ? "not-allowed" : "text"}; /* Change cursor if disabled */

  &::placeholder {
    color: #adb5bd;
    opacity: 1; /* Firefox */
  }

  &::-ms-input-placeholder {
    /* Edge 12 -18 */
    color: #adb5bd;
  }

  &:focus {
    border-color: #004f96;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
    outline: none;
  }
`;

export default NHSNumberInput;
